﻿<div class="card card-default rdo-card rdo-card-default" [ngClass]="{'rdo-card-bench' : isBenchmarkMode(), 'rdo-card-book': !isBenchmarkMode()}">
  <div class="card-header">
    <div class="card-title top-list-title" id="{{title | rdoPathToId}}">{{title | translate}}</div>
  </div>
  <table class="table table-nowrap">
    <tbody>
      <tr>
        <th></th>
        @if (isBenchmarkMode()) {
          <th id="{{title + '.client_compared' | rdoPathToId}}" class="rdo-table-title rdo-narrow-title"><div
          >{{'main.tabs.summary.tables.client_compared_revenue' | translate}}</div></th>
          <th id="{{title + '.client_rate_vs.1' | rdoPathToId}}" class="rdo-table-title rdo-wide-title"><div
          >{{'main.tabs.summary.tables.client_rate_vs_benchmark' | translate}}</div></th>
        }
        @if (!isBenchmarkMode()) {
          <th id="{{title + '.client_total' | rdoPathToId}}" class="rdo-table-title rdo-narrow-title"><div
          >{{'main.tabs.summary.tables.client_total_revenue' | translate}}</div></th>
          <th id="{{title + '.client_rate_vs.2' | rdoPathToId}}" class="rdo-table-title rdo-wide-title"><div
          >{{'main.tabs.summary.tables.client_rate_vs_book' | translate}}</div></th>
        }
      </tr>
      @for (i of items; track i) {
        <tr>
          <td>
            <span title="{{i[nameSelector]}}">
              @if (linkUrl) {
                <a (click)="handleClick(i)" [href]="linkUrl(router, location, i)">
                  {{i[nameSelector]}}
                </a>
              }
              @if (!linkUrl) {
                <span>
                  {{i[nameSelector]}}
                </span>
              }
            </span>
          </td>
          @if (isBenchmarkMode()) {
            <td [ngClass]="{'text-muted':i.ClientBenchmarkedRevenue === 0}">
              {{i.ClientBenchmarkedRevenue | rdoCurrency:true}}
            </td>
            <td>
              <rdo-amount-difference [clientValue]="i.ClientBenchmarkedRevenue" [benchmarkedValue]="i.BenchmarkedRevenue"></rdo-amount-difference>
            </td>
          }
          @if (!isBenchmarkMode()) {
            <td [ngClass]="{'text-muted':i.RevenueTotal === 0}">
              {{i.RevenueTotal | rdoCurrency:true}}
            </td>
            <td>
              <rdo-amount-difference [clientValue]="i.RevenueTotal" [benchmarkedValue]="i.RevenueBook"></rdo-amount-difference>
            </td>
          }
        </tr>
      }
    </tbody>
    <tfoot>
      <tr>
        <td colspan="3">
          @if (footerLinkDsl) {
            <a [routerLink]="footerLinkDsl" id="{{title + '.all' | rdoPathToId}}">{{getFooterLinkTitle(footerLinkTitle)}}<i class="fa fa-fw fa-angle-double-right"></i></a>
          }
        </td>
      </tr>
    </tfoot>
  </table>
</div>
